import React from 'react';
import { connect } from 'react-redux';
import {
  Button, Card, CardBody, CardTitle,
} from 'reactstrap';
import { Form, actions } from 'react-redux-form/immutable';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import qs from 'qs';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { LabeledText } from '../../../../../form/LabeledText';
import { LabeledSelect } from '../../../../../form/LabeledSelect';
import { volcanoEventSearchModel, toSearchParameters } from './volcanoEventSearchModel';
import {
  clearVolcanoEvents as clearVolcanoEventsAc,
  getVolcanoEvents as getVolcanoEventsAc,
  getCountries as getCountriesAc,
  getRegions as getRegionsAc,
  getVolcanoNames as getVolcanoNamesAc,
  getMorphologies as getMorphologiesAc,
} from '../../../../../../redux/volcanoes/event/search/volcanoEventSearchActions';
import { Loading } from '../../../../../loadbar/Loading';
import { withUser } from '../../../../../auth/withUser';
import { isDataManager } from '../../../../../../role/roleUtils';
import { MinMaxSearchCard } from '../../../../../form/search/MinMaxSearchCard';
import { TextMatchSearchCard } from '../../../../../form/search/TextMatchSearchCard';
import { LatLongSearchCard } from '../../../../../form/search/LatLongSearchCard';
import { EffectsSearchCard } from '../../../../../form/search/EffectsSearchCard';

const model = volcanoEventSearchModel.get('name');

class VolcanoEventSearchPageUnwrapped extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    document.title = 'NCEI Hazard Volcano Event Search';
    const {
      clearVolcanoEvents, getCountries, getVolcanoNames, getMorphologies, getRegions, history,
    } = this.props;
    clearVolcanoEvents();
    getCountries({ history });
    getRegions({ history });
    getVolcanoNames({ history });
    getMorphologies({ history });
  }

  handleSubmit(form) {
    const { getVolcanoEvents, history } = this.props;
    const queryParameters = toSearchParameters(form);
    const location = {
      pathname: '/view/hazards/volcano/event-data',
      search: qs.stringify(toSearchParameters(form), { skipNulls: true }),
    };
    getVolcanoEvents({
      queryParameters, formModel: model, history, location, searchRedirect: true,
    });
  }

  render() {
    const {
      resetForm,
      loading,
      countries,
      regions,
      volcanoNames,
      morphologies,
      peopleDescriptors,
      damageDescriptors,
      fetched,
      authorities,
    } = this.props;
    if (loading || !fetched) {
      return (<Loading />);
    }

    const regionsJS = regions.toJS().map(x => ({ id: x.id, description: `${(`00${x.id}`).slice(-2)} - ${x.description}` }));
    const peopleDescriptorsJs = peopleDescriptors.toJS();
    const damageDescriptorsJs = damageDescriptors.toJS();
    const eruptionJs = [{ id: 'true', description: 'Yes = As defined by the Smithsonian Institution\'s Global Volcanism Program (GVP), a volcanic event that involves the explosive ejection of fragmental material, the effusion of molten lava, or both; includes older events with a combination of unknown characteristics.' },
      { id: 'false', description: 'No = Significant volcanic event (death, damage, etc.) not characterized by an eruption.' }];

    const dataManager = isDataManager(authorities);

    return (
      <div className="haz-results-container haz-page-container">
        <Card className="haz-page-card">
          <CardBody>
            <CardTitle tag="h1" className="haz-page-card-title">Search Volcano Events</CardTitle>
            <p>
              The Significant Volcanic Eruption Database is a
              global listing of over 800 significant eruptions which
              includes information on the latitude, longitude, elevation,
              type of volcano, and last known eruption.
              A significant eruption is classified as one that meets at least
              one of the following criteria: caused fatalities, caused moderate
              damage (approximately $1 million or more), with a Volcanic
              Explosivity Index (VEI) of 6 or larger, caused a tsunami, or was
              associated with a major earthquake. For a complete list of current
              and past activity for all volcanoes on the planet active during
              the last 10,000 years,please see
              {' '}
              <a
                href="https://volcano.si.edu/"
                rel="noopener noreferrer"
                target="_blank"
                title="Smithsonian Institution-Global Volcanism Program"
                aria-label="Smithsonian Institution-Global Volcanism Program"
              >
                Smithsonian Institution&#39;s Global Volcanism Program (GVP).
              </a>
              The database can also be displayed and extracted with the
              {' '}
              <a
                href="http://maps.ngdc.noaa.gov/viewers/hazards?layers=3"
                rel="noopener noreferrer"
                target="_blank"
                title="Natural Hazards Viewer"
                aria-label="Natural Hazards Viewer"
              >
                Natural Hazards Interactive Map
              </a>
            </p>
            <p>
              Please cite as:
              <br />
              {' '}
              <b>
                National Geophysical Data Center / World Data Service (NGDC/WDS): NCEI/WDS Global Significant Volcanic Eruptions Database. NOAA National Centers for Environmental Information.
                {' '}
                <a href="http://dx.doi.org/10.7289/V5JW8BSH" rel="noopener noreferrer" target="_blank" title="Earthquake DOI Information" aria-label="Earthquake DOI Information">doi:10.7289/V5JW8BSH</a>
              </b>
            </p>
            <Form model={model} onSubmit={this.handleSubmit} noValidate>

              <div>
                <Button color="primary" type="submit" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" onClick={resetForm}>Clear</Button>
              </div>
              <br />

              { dataManager && (
              <Card>
                <CardBody>
                  <CardTitle tag="h2">Volcano Event ID</CardTitle>
                  <LabeledText model=".id" label="ID" />
                  <MinMaxSearchCard min=".minId" max=".maxId">Volcano Event ID Range</MinMaxSearchCard>
                </CardBody>
              </Card>
              )}

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Volcano Parameters</CardTitle>

                  {dataManager && (
                  <div className="form-row">
                    <LabeledText
                      formGroupClassName={['col-sm-4']}
                      model=".locId"
                      label="NCEI ID"
                    />
                    <LabeledText
                      formGroupClassName={['col-sm-4']}
                      model=".locPreviousNum"
                      label="Previous Volcano Number"
                    />
                    <LabeledText
                      formGroupClassName={['col-sm-4']}
                      model=".locNum"
                      label="Volcano Number"
                    />
                  </div>
                  )}


                  <MinMaxSearchCard min=".minYear" max=".maxYear" helpModalId="volEventYear">Year</MinMaxSearchCard>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.nameSearchType"
                    textModel=".radios.name"
                    startsWith="nameStart"
                    includes="nameInclude"
                    matches="nameMatch"
                    doesNotMatch="nameNot"
                    helpModalId="volLocName"
                  >
                    Volcano Name
                  </TextMatchSearchCard>

                  <LabeledSelect
                    parentModel={model}
                    fieldId="nameMatch"
                    label="Volcano Name Selection"
                    helpModalId="volLocName"
                    filterable
                    childOptions={volcanoNames.toJS()}
                  />

                  <div className="form-row">
                    <LabeledSelect
                      formGroupClassName={['col-lg-6']}
                      parentModel={model}
                      fieldId="country"
                      label="Country"
                      helpModalId="volEventCountry"
                      filterable
                      childOptions={countries.toJS()}
                    />
                    <LabeledSelect
                      formGroupClassName={['col-lg-6']}
                      parentModel={model}
                      fieldId="region"
                      label="Region"
                      helpModalId="volLocRegions"
                      filterable
                      childOptions={regionsJS}
                    />
                  </div>
                  <TextMatchSearchCard
                    radioGroupModel=".radios.locationSearchType"
                    textModel=".radios.loc"
                    startsWith="locStart"
                    includes="locInclude"
                    matches="locMatch"
                    doesNotMatch="locNot"
                    helpModalId="volLocRegion"
                  >
                    Volcano Location
                  </TextMatchSearchCard>

                  <LatLongSearchCard model={model} />
                  <div className="form-row">
                    <LabeledSelect
                      formGroupClassName={['col-md-6']}
                      parentModel={model}
                      fieldId="morphology"
                      label="Volcano Type"
                      helpModalId="volLocType"
                      filterable
                      childOptions={morphologies.toJS()}
                    />
                    {dataManager && (
                    <LabeledSelect formGroupClassName={['col-md-6']} childOptions={eruptionJs} parentModel={model} fieldId="eruption" label="Volcano Eruption" sorted={false} helpModalId="volEventEruption" />
                    )}
                  </div>
                  <MinMaxSearchCard min=".minVei" max=".maxVei" helpModalId="volEventVei">VEI</MinMaxSearchCard>

                  <TextMatchSearchCard
                    radioGroupModel=".radios.commentsSearchType"
                    textModel=".radios.comments"
                    startsWith="commentsStart"
                    includes="commentsInclude"
                    matches="commentsMatch"
                    doesNotMatch="commentsNot"
                    helpModalId="volEventComments"
                  >
                    Event Comments
                  </TextMatchSearchCard>

                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle tag="h2">Hazard Association</CardTitle>
                  <div className="form-row">
                    <LabeledSelect
                      formGroupClassName={['col-md-6']}
                      parentModel={model}
                      fieldId="assocTsu"
                      label="Tsunami"
                      unselectedText="None Selected"
                      helpModalId="volTsunami"
                      childOptions={[
                        { id: 'yes', description: 'Tsunami Was Associated' },
                        { id: 'no', description: 'Tsunami Was Not Associated' },
                      ]}
                    />
                    <LabeledSelect
                      formGroupClassName={['col-md-6']}
                      parentModel={model}
                      fieldId="assocEq"
                      label="Earthquake"
                      unselectedText="None Selected"
                      helpModalId="volEarthquake"
                      childOptions={[
                        { id: 'yes', description: 'Earthquake Was Associated' },
                        { id: 'no', description: 'Earthquake Was Not Associated' },
                      ]}
                    />
                  </div>
                </CardBody>
              </Card>

              <EffectsSearchCard helpModalIdPrefix="volEvent" deaths damage peopleDescriptors={peopleDescriptorsJs} model={model} damageDescriptors={damageDescriptorsJs}>Volcano Effects</EffectsSearchCard>

              <br />
              <div>
                <Button color="primary" type="submit" aria-label="Search Option 2" className="ml-5">Search</Button>
                <Button color="secondary" className="ml-3" aria-label="Clear Option 2" onClick={resetForm}>Clear</Button>
              </div>

            </Form>
            <br />
            <p>
              A significant eruption is classified as one that meets at least one of the following criteria: caused fatalities, caused moderate damage (approximately $1 million or more), with a Volcanic Explosivity Index (VEI) of 6 or larger, caused a tsunami, or was associated with a major earthquake. For a complete list of current and past activity for all volcanoes on the planet active during the last 10,000 years, please see Smithsonian Institution&#39;s
              {' '}
              <a href={window.externalGlobalVolcanismLink} target="_blank" rel="noopener noreferrer">Global Volcanism Program (GVP)</a>
              .
            </p>
          </CardBody>
        </Card>
      </div>
    );
  }
}

VolcanoEventSearchPageUnwrapped.propTypes = {
  resetForm: PropTypes.func.isRequired,
  clearVolcanoEvents: PropTypes.func.isRequired,
  getVolcanoEvents: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  countries: ImmutablePropTypes.list.isRequired,
  regions: ImmutablePropTypes.list.isRequired,
  volcanoNames: ImmutablePropTypes.list.isRequired,
  morphologies: ImmutablePropTypes.list.isRequired,
  getCountries: PropTypes.func.isRequired,
  getRegions: PropTypes.func.isRequired,
  getVolcanoNames: PropTypes.func.isRequired,
  getMorphologies: PropTypes.func.isRequired,
  fetched: PropTypes.bool.isRequired,
  peopleDescriptors: ImmutablePropTypes.list.isRequired,
  damageDescriptors: ImmutablePropTypes.list.isRequired,
  history: PropTypes.shape({}).isRequired,
  authorities: ImmutablePropTypes.list.isRequired,
};


const mapStateToProps = state => ({
  loading: state.getIn(['volcanoEventSearch', 'loading']),
  countries: state.getIn(['volcanoEventSearch', 'countries']),
  regions: state.getIn(['volcanoEventSearch', 'regions']),
  volcanoNames: state.getIn(['volcanoEventSearch', 'volcanoNames']),
  morphologies: state.getIn(['volcanoEventSearch', 'morphologies']),
  damageDescriptors: state.getIn(['effectDescriptors', 'damage']),
  peopleDescriptors: state.getIn(['effectDescriptors', 'people']),
  fetched: [
    state.getIn(['volcanoEventSearch', 'fetchedRegions']),
    state.getIn(['volcanoEventSearch', 'fetchedCountries']),
    state.getIn(['volcanoEventSearch'], 'fetchedVolcanoNames'),
    state.getIn(['volcanoEventSearch', 'fetchedMorphologies']),
  ].every(v => v),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  clearVolcanoEvents: clearVolcanoEventsAc,
  getVolcanoEvents: getVolcanoEventsAc,
  resetForm: () => actions.reset(model),
  getCountries: getCountriesAc,
  getRegions: getRegionsAc,
  getVolcanoNames: getVolcanoNamesAc,
  getMorphologies: getMorphologiesAc,
}, dispatch);

export const VolcanoEventSearchPage = withUser(connect(mapStateToProps, mapDispatchToProps)(VolcanoEventSearchPageUnwrapped));
